"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentMultiple = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var controlled_1 = require("../form/controlled");
var button_1 = require("../button");
var config_context_1 = require("../_util/config-context");
var SegmentGroup_1 = require("./SegmentGroup");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var merge_event_props_1 = require("../_util/merge-event-props");
exports.SegmentMultiple = forward_ref_with_statics_1.forwardRefWithStatics(function SegmentMultiple(props, ref) {
    var _a = controlled_1.useDefaultValue(props), value = _a.value, onChange = _a.onChange, groups = _a.groups, groupClassName = _a.groupClassName, groupStyle = _a.groupStyle, options = _a.options;
    var valueSet = new Set(value);
    if (groups) {
        return (react_1.default.createElement(SegmentGroup_1.SegmentGroup, { ref: ref, className: groupClassName, style: groupStyle }, Object.entries(groups).map(function (_a) {
            var _b = tslib_1.__read(_a, 2), key = _b[0], name = _b[1];
            var subOptions = options.filter(function (i) { return i.groupKey === key; });
            return (react_1.default.createElement(SegmentGroup_1.SegmentGroupItem, { name: name, key: key },
                react_1.default.createElement(SegmentMain, tslib_1.__assign({}, props, { valueSet: valueSet, options: subOptions, allOptions: options, value: value, onChange: onChange }))));
        })));
    }
    return (react_1.default.createElement(SegmentMain, tslib_1.__assign({}, props, { valueSet: valueSet, value: value, onChange: onChange })));
}, {
    defaultLabelAlign: "middle",
});
exports.SegmentMultiple.displayName = "SegmentMultiple";
var SegmentMain = react_1.default.forwardRef(function SegmentMain(_a, ref) {
    var _b;
    var onChange = _a.onChange, rimless = _a.rimless, options = _a.options, style = _a.style, className = _a.className, 
    // 兼容分组
    valueSet = _a.valueSet, _c = _a.allOptions, allOptions = _c === void 0 ? options : _c, props = tslib_1.__rest(_a, ["onChange", "rimless", "options", "style", "className", "valueSet", "allOptions"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-segment", className, (_b = {},
            _b[classPrefix + "-segment--rimless"] = rimless,
            _b)), style: style }, merge_event_props_1.mergeEventProps(props)), options.map(function (option) { return (react_1.default.createElement(button_1.Button, { key: option.value, htmlType: "button", disabled: option.disabled, tooltip: option.tooltip, className: classnames_1.default(option.className, {
            "is-selected": valueSet.has(option.value),
        }), style: option.style, onClick: option.disabled
            ? null
            : function (event) {
                var newValue;
                // 之前已经选中，新值排除此值
                if (valueSet.has(option.value)) {
                    newValue = allOptions
                        .filter(function (x) { return x !== option && valueSet.has(x.value); })
                        .map(function (x) { return x.value; });
                }
                // 之前没有选中，新值包含次值
                else {
                    newValue = allOptions
                        .filter(function (x) { return x === option || valueSet.has(x.value); })
                        .map(function (x) { return x.value; });
                }
                onChange(newValue, { event: event });
            } }, option.text || option.value)); })));
});
SegmentMain.displayName = "SegmentMain";
//# sourceMappingURL=SegmentMultiple.js.map